import { isQuarterPoint, QUARTER_MESSAGE, weekGoalError } from "@/lib/points";
import type { MealLogConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";
import { maxScoreWeek } from "./scoring";

export function validate(config: MealLogConfig): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  const badThreshold = config.conditions.some(
    (c) => !Number.isFinite(c.threshold) || c.threshold <= 0,
  );
  if (badThreshold) {
    errors.conditions = "Alle betingelser må ha en grense over 0.";
  }
  const badPoints = config.conditions.some(
    (c) => !Number.isFinite(c.points) || c.points <= 0,
  );
  if (badPoints) {
    errors.conditionPoints = "Alle betingelser må gi poeng over 0.";
  } else if (config.conditions.some((c) => !isQuarterPoint(c.points))) {
    errors.conditionPoints = QUARTER_MESSAGE;
  }
  // Absent in pure tracking: with no conditions there is nothing to aim at.
  if (config.conditions.length > 0) {
    const goalError = weekGoalError(config.weekGoal ?? Number.NaN, {
      max: maxScoreWeek(config),
    });
    if (goalError) errors.weekGoal = goalError;
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
